import { COMMA, ENTER } from "@angular/cdk/keycodes";
import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { MatAutocompleteSelectedEvent } from "@angular/material/autocomplete";
import { MatChipInputEvent } from "@angular/material/chips";
import { Store } from "@ngrx/store";
import { EntityLabelLinkService, EntityService, Pagination } from "blg-akaun-ts-lib";
import { SessionSelectors } from "../../modules/session/session-controller/selectors";
import { SessionStates } from "../../modules/session/session-controller/states";
import { AppConfig } from "../../visa";
import { Observable } from "rxjs";
import {
  debounceTime,
  distinctUntilChanged,
  map,
} from "rxjs/operators";
import { SubSink } from "subsink2";

@Component({
  selector: "app-purchaser",
  templateUrl: "./purchaser.component.html",
  styleUrls: ["./purchaser.component.css"],
})
export class PurchaserComponent implements OnInit, OnDestroy {
  @Input() purchaserControl = new FormControl();
  @Output() selectionChange = new EventEmitter();
  @Input() viewModelStore;
  @Input() ColumnViewActions;
  @Input() ColumnViewSelectors;
  @Input() readPermissionDefintion;

  pagination = new Pagination();

  private subs = new SubSink();
  separatorKeysCodes: number[] = [ENTER, COMMA];
  filteredPurchasers$: Observable<any[]>;
  purchasers: any[] = [];
  allPurchasers: any[] = [];
  toppingsControl = new FormControl([]);
  filteredPurchasers: any[] = [];
  newFilteredPurchasers: any[] = [];

  labels: any;
  appletSettings$ =  this.sessionStore.select(SessionSelectors.selectMasterSettings)

  constructor(
    private entityService: EntityService,
    protected readonly sessionStore: Store<SessionStates>,
    private entityLabelLinkService: EntityLabelLinkService
  ) {}

  async ngOnInit(): Promise<void> {
    this.subs.sink = this.sessionStore.select(SessionSelectors.selectMasterSettings).subscribe(data => {
      // console.log("DEBUG::::::::::session data loaded: ",data );
      this.labels = data.salesManLabels;
    })
    this.viewModelStore
      .select(this.ColumnViewSelectors.selectAdvanceSearch_Purchaser_Field)
      .subscribe((data) => {
        this.purchasers = data;
      });
      if (this.labels?.length > 0) {
        this.pagination.conditionalCriteria = [
          { columnName: "calcTotalRecords", operator: "=", value: "true" },
          { columnName: "namespace", operator: "=", value: "EMPLOYEE_CATEGORY" },
          { columnName: "label_hdr_guids", operator: "=", value: this.labels },
        ];
      } else {
        this.pagination.conditionalCriteria = [
          { columnName: "calcTotalRecords", operator: "=", value: "true" },
          { columnName: "namespace", operator: "=", value: "EMPLOYEE_CATEGORY" },
        ];
      }
  
      let entityHdrGuids: string[] = [];
      try {
        const response = await this.entityLabelLinkService
          .getByCriteria(this.pagination, AppConfig.apiVisa)
          .toPromise();
  
        entityHdrGuids = response.data
          .map((item) =>
            item.bl_fi_mst_entity_label_link.entity_hdr_guid?.toString()
          )
          .filter((guid) => !!guid);
  
        if (entityHdrGuids.length > 0) {
          const entityResponse = await this.entityService
            .getByCriteria(
              new Pagination(0, 1000, [
                {
                  columnName: "hdr_guids",
                  operator: "=",
                  value: entityHdrGuids.toString(),
                },
                {
                  columnName: "is_employee",
                  operator: "=",
                  value: "true",
                },
              ]),
              AppConfig.apiVisa
            )
            .toPromise();
          this.filteredPurchasers = entityResponse.data; 
          this.newFilteredPurchasers = entityResponse.data
        }
      } catch (error) {
        // Handle errors here
        console.error(error);
      }
  
      this.purchaserControl.valueChanges
      .pipe(debounceTime(300), distinctUntilChanged())
      .subscribe((data) => this.filterPurchaser(data));
    }
    

  add(event: MatChipInputEvent): void {
    const value = (event.value || "").trim();
    // Add our purchaser
    if (value) {
      this.purchasers.push(value);
    }
    // Clear the input value
    event.input.value = "";

    this.purchaserControl.setValue(null);

    this.viewModelStore.dispatch(
      this.ColumnViewActions.setAdvanceSearch_PurchaserField({
        purchasers: this.purchasers
      })
    );
  }

  remove(purchaser: string): void {
    const index = this.purchasers.indexOf(purchaser);

    if (index >= 0) {
      this.purchasers[index].selected = false;
      this.purchasers.splice(index, 1);
    }
    this.viewModelStore.dispatch(
      this.ColumnViewActions.setAdvanceSearch_PurchaserField({
        purchasers: this.purchasers,
      })
    );
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    console.log(event.option);
    this.purchasers.push(event.option.value);
    this.purchaserControl.setValue(null);
  }

  filterPurchaser(filterValue: string) {
    filterValue = filterValue?.trim().toLowerCase(); // Remove whitespace and make it lowercase
    this.filteredPurchasers = this.newFilteredPurchasers.filter((option) =>
      option.bl_fi_mst_entity_hdr.employee_code.toLowerCase().includes(filterValue)
    );
  }

  optionClicked(event: Event, purchaser: any) {
    event.stopPropagation();
    this.toggleSelection(purchaser);
  }

  toggleSelection(purchaser: any) {
    purchaser.selected = !purchaser.selected;
    if (purchaser.selected) {
      this.purchasers.push(purchaser);
    } else {
      const i = this.purchasers.findIndex((value) => value.guid === purchaser.guid);
      this.purchasers.splice(i, 1);
    }
    // console.log("Debug:::this.purchaser:", this.purchasers);
    this.viewModelStore.dispatch(
      this.ColumnViewActions.setAdvanceSearch_PurchaserField({
        purchasers: this.purchasers,
      })
    );
  }

  onReset() {
    this.purchasers = [];
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
